import { SplunkReporter } from 'reporting/splunk/SplunkReporter';

/**
 * Centralized Splunk logging for batch payment feature
 * Non-hook version for use in Redux slices and server code
 * Provides type-safe logging methods for all batch payment events
 */

const splunkReporter = SplunkReporter.getInstance();

/**
 * Log when batch payment initiation succeeds
 * Note: We removed the "start" log to reduce redundancy - this success log is sufficient
 */
export const logInitiateBatchPaymentSuccess = (logger: string, params: { batchId: string }) => {
  splunkReporter.contextual({
    event: 'batchPayment',
    action: 'initiateBatchPayment',
    logInfo: { logLevel: 'info', logger },
    activityInfo: {
      batchId: params.batchId,
      success: true,
    },
  });
};

/**
 * Log when batch payment initiation fails (no selected invoices)
 */
export const logInitiateBatchPaymentNoInvoices = (logger: string) => {
  splunkReporter.contextual({
    event: 'batchPayment',
    action: 'initiateBatchPayment',
    logInfo: { logLevel: 'error', logger },
    error: { message: 'No selected invoices available for batch payment' },
  });
};

/**
 * Log when tokenization fails during batch payment
 */
export const logTokenizationError = (logger: string, error: Error) => {
  splunkReporter.contextual({
    event: 'batchPayment',
    action: 'tokenization',
    logInfo: { logLevel: 'error', logger },
    error: {
      message: error?.message || 'Tokenization failed',
      stack: error?.stack,
    },
  });
};

/**
 * Log when batch payment API call fails
 */
export const logBatchPaymentError = (logger: string, error: Error) => {
  splunkReporter.contextual({
    event: 'batchPayment',
    action: 'initiateBatchPayment',
    logInfo: { logLevel: 'error', logger },
    error: {
      message: error?.message || 'Batch payment failed',
      stack: error?.stack,
    },
  });
};

/**
 * Log card on file checkbox state when initiating batch payment
 */
export const logCardOnFileCheckboxState = (
  logger: string,
  params: {
    isSavePaymentMethodChecked: boolean;
    isNewPaymentMethod: boolean;
  }
) => {
  splunkReporter.contextual({
    event: 'batchPayment',
    action: 'cardOnFileCheckboxState',
    logInfo: { logLevel: 'info', logger },
    activityInfo: {
      isSavePaymentMethodChecked: params.isSavePaymentMethodChecked,
      isNewPaymentMethod: params.isNewPaymentMethod,
    },
  });
};
